import Vue from 'vue'

Vue.mixin({
    methods: {
        capitalize(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        uclower(str) {
            return str.charAt(0).toLowerCase() + str.slice(1);
        },

        isEmailValid(email) {
            if (/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email)) {
                return true;
            }

            return false;
        },

        isValidatedProfile(profile) {

            if(profile.billing_type == 'pf') return true;
            if(profile.country != 1) return true;

            return profile.validated_cui;
        },

        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },

        isDesktop() {

            return !this.isMobile();
        },

        isValidatedCui(profile)
        {
            if(profile.validated_cui == 1) {
                return true;
            }

            if(profile.validated_cui == 0) {
                return false;
            }

            return profile.validated_cui;
        },

        validateROCui(profile)
        {
            if(profile.country != 1) return true;

            var str = profile.fiscal_code;

            // console.log(str.substring(1, 2).toUpperCase())

            if(str.substring(0, 1).toUpperCase() == 'R' && str.length == 1) return true;
            if(str.substring(1, 2).toUpperCase() == 'O' && str.length == 2) return true;

            let ok = this.isNumber(str);

            if(!ok) {

                if(str.substring(0, 2).toUpperCase() == 'RO') {

                     if(str.length > 2 && !this.isNumber(str.substring(2))) {


                        profile.fiscal_code = '';
                     }

                } else {

                    profile.fiscal_code = '';
                }
            }
        },

        isNumber(str) {

            let ok = true;

            if (typeof str != "string") {
                ok = false;
            }

            ok =  !isNaN(str) && !isNaN(parseFloat(str))

            return ok;
        },

        clearErrors(errors)
        {
            for (const property in errors) {
                errors[property] = '';
            }
        },

        validatePlateNo(plateNo, country) {

            if(country == 1) {
                let regexp = new RegExp(this.$store.getters['settings/getNumberRegex']);
                return regexp.test(plateNo);
            }

            return true;
        },

        validateChasisNo(chasisNo) {

            if(chasisNo.length <= 17) return true;

            return false;
        },
        getDateObject(date) {
            if(typeof date === 'string' && date.match(/\d+\.\d+\.\d+/)) {
                let day = date.split('.')[0];
                let month = date.split('.')[1];
                let year = date.split('.')[2];

                return new Date(year, month - 1, day);
            }

            return new Date(date);
        },
        formatDate(date, char = '.') {
            if(typeof date === 'string' && date.match(/\d+\.\d+\.\d+/)) {
                day = date.split('.')[0];
                month = date.split('.')[1];
                year = date.split('.')[2];
            }
            else {
                var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;
            }

            return [day, month, year].join(char);
        },

        isToday(someDate) {
          let today = new Date();
          return someDate.getDate() == today.getDate() && someDate.getMonth() == today.getMonth() && someDate.getFullYear() == today.getFullYear();
        },

        isDateInFutureNotWeekend(date) {
            var d = new Date();
            d.setDate(d.getDate() + (1 + 7 - d.getDay()) % 7); //next Monday or this Monday is today is Monday
            d.setHours(0, 0, 0, 0);

            if(date.getTime() >= d.getTime()) {
                return true;
            }

            return false;
        },

        isDateInPast(date) {
            let d = new Date(this.getDateObject(date));
            d.setHours(0, 0, 0, 0);

            let now = new Date();
            now.setHours(0, 0, 0, 0);

            return d.getTime() < now.getTime();
        },

        getAlertByType(type) {
            return this.$store.getters['settings/getAlerts'](type)
        },

        openUrl(path, download = true, location = 'yes') {
            if(window.cordova && ['android', 'ios'].includes(window.cordova.platformId)) {
                return window.cordova.InAppBrowser.open(path, download ? '_system' : '_blank', 'location=' + location);
            }
            else {
                return window.location = path;
            }
        },

        os() {
            return process.env.VUE_APP_DEVICE;
        }
    }
})
